import * as Sentry from "@sentry/browser"

declare global {
  interface Window {
    __sentryOptions?: {
      dsn: string;
      release: string,
      environment: string,
      sampleRate: number,
      tracesSampleRate: number,
    }
  }
}

const opts = window.__sentryOptions;

if (opts) {
  Sentry.init({
    dsn: opts.dsn,
    release: opts.release,
    environment: opts.environment,
    sampleRate: opts.sampleRate,
    tracesSampleRate: opts.tracesSampleRate,
    integrations: [
      Sentry.browserSessionIntegration(),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys:[
          "ac-js-bundle",
        ],
        behaviour: "apply-tag-if-exclusively-contains-third-party-frames",
      })
    ],
  })
}

